import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const tailorBoardColumnsNudgeEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-tailor-board-columns-nudge-entrypoint" */ './index'),
	),
	getPreloadProps: () => ({}),
});
